import { useState } from "react";
import { Aviso, Botao, Cartao, Segmentado } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import { useDuplicados, type TipoDeImportacao } from "../../nucleo/cadastro";
import { FusaoEmCurso } from "./FusaoEmCurso";

const TIPOS = [
  { valor: "organizacoes", rotulo: "Organizações" },
  { valor: "pessoas", rotulo: "Pessoas" },
] as const;

interface Escolha {
  destino: { id: string; nome: string };
  origem: { id: string; nome: string };
}

/**
 * Candidatos a duplicata, em grupos. O sistema só sugere; quem decide qual cadastro fica é a
 * pessoa, e a fusão passa pela prévia antes de valer.
 */
export function PainelDeDuplicados() {
  const [tipo, setTipo] = useState<TipoDeImportacao>("organizacoes");
  const grupos = useDuplicados(tipo);
  const [escolha, setEscolha] = useState<Escolha | null>(null);

  return (
    <div data-testid="painel-de-duplicados">
      <p className="lead mb-3">
        Cadastros que parecem ser o mesmo. Escolha qual fica e funda os outros nele: chamados,
        pessoas, ativos e histórico passam para o que fica.
      </p>
      <Segmentado
        rotulo="O que procurar"
        itens={TIPOS}
        valor={tipo}
        aoMudar={(novo) => {
          setTipo(novo);
          setEscolha(null);
        }}
        className="mb-3"
      />
      {grupos.isPending ? <p role="status">Procurando duplicados…</p> : null}
      {grupos.isError ? <Aviso tom="erro">{mensagemDoConsole(grupos.error)}</Aviso> : null}
      {grupos.data && grupos.data.length === 0 ? (
        <Aviso tom="sucesso">Nenhum candidato a duplicata por enquanto.</Aviso>
      ) : null}
      {grupos.data?.map((grupo, indice) => (
        <Cartao
          key={`${grupo.motivo}-${indice}`}
          titulo={grupo.motivo}
          className="mb-3"
          data-testid={`grupo-de-duplicados-${indice}`}
        >
          <ul>
            {grupo.itens.map((item) => (
              <li key={item.id} className="flex items-center justify-between gap-3 py-1">
                <span>
                  <b>{item.nome}</b>
                  {item.detalhe ? <span className="celula-secundaria"> · {item.detalhe}</span> : null}
                </span>
                <span className="flex gap-2">
                  {grupo.itens
                    .filter((outro) => outro.id !== item.id)
                    .map((outro) => (
                      <Botao
                        key={outro.id}
                        tamanho="pequeno"
                        variante="fantasma"
                        aria-label={`Manter ${item.nome} e fundir ${outro.nome} nele`}
                        onClick={() =>
                          setEscolha({
                            destino: { id: item.id ?? "", nome: item.nome ?? "" },
                            origem: { id: outro.id ?? "", nome: outro.nome ?? "" },
                          })
                        }
                      >
                        Manter este e fundir “{outro.nome}”
                      </Botao>
                    ))}
                </span>
              </li>
            ))}
          </ul>
        </Cartao>
      ))}
      {escolha ? (
        <FusaoEmCurso
          tipo={tipo}
          destino={escolha.destino}
          origem={escolha.origem}
          aoCancelar={() => setEscolha(null)}
          aoConcluir={() => setEscolha(null)}
        />
      ) : null}
    </div>
  );
}
